var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AreaFormModel } from '.';
import { TargetAreaTypes } from '../Constants';
var TemporaryMansionMenuSettingFormModel = /** @class */ (function () {
    function TemporaryMansionMenuSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.orderDescription, orderDescription = _b === void 0 ? {} : _b;
        var _c = orderDescription, _d = _c.priceTarget, priceTarget = _d === void 0 ? {} : _d, _e = _c.floorTarget, floorTarget = _e === void 0 ? {} : _e, _f = _c.ageBuilt, ageBuilt = _f === void 0 ? {} : _f, _g = _c.floorPlan, floorPlan = _g === void 0 ? {} : _g, _h = _c.administrativeDistrictType, administrativeDistrictType = _h === void 0 ? TargetAreaTypes.PREFECTURE : _h, area = _c.area, _j = _c.splitGroup, splitGroup = _j === void 0 ? false : _j, _k = _c.memo, memo = _k === void 0 ? '' : _k;
        this.id = id;
        this.orderDescription = {
            priceTarget: PriceTargetFormModel.assign(priceTarget),
            floorTarget: FloorTargetFormModel.assign(floorTarget),
            ageBuilt: AgeBuildFormModel.assign(ageBuilt),
            floorPlan: FloorPlanFormModel.assign(floorPlan),
            administrativeDistrictType: administrativeDistrictType,
            area: AreaFormModel.assign(area),
            splitGroup: splitGroup,
            memo: memo,
            isValidPriceTarget: Object.keys(priceTarget).length !== 0,
            isValidFloorTarget: Object.keys(floorTarget).length !== 0,
            isValidAgeBuilt: Object.keys(ageBuilt).length !== 0,
            isValidFloorPlan: Object.keys(floorPlan).length !== 0,
        };
    }
    TemporaryMansionMenuSettingFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.orderDescription.area.init(this.orderDescription.administrativeDistrictType)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TemporaryMansionMenuSettingFormModel.prototype, "isSimulatable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryMansionMenuSettingFormModel.prototype, "isNew", {
        get: function () {
            return !this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryMansionMenuSettingFormModel.prototype, "hasNoConditions", {
        get: function () {
            return (!this.orderDescription.isValidPriceTarget &&
                !this.orderDescription.isValidFloorTarget &&
                !this.orderDescription.isValidAgeBuilt &&
                !this.orderDescription.isValidFloorPlan);
        },
        enumerable: false,
        configurable: true
    });
    return TemporaryMansionMenuSettingFormModel;
}());
export { TemporaryMansionMenuSettingFormModel };
var PriceTargetFormModel = /** @class */ (function () {
    function PriceTargetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.minPrice, minPrice = _b === void 0 ? 0 : _b, _c = _a.maxPrice, maxPrice = _c === void 0 ? null : _c;
        this.minPrice = minPrice;
        this.maxPrice = maxPrice;
    }
    PriceTargetFormModel.assign = function (data) {
        return new PriceTargetFormModel(data);
    };
    return PriceTargetFormModel;
}());
var FloorTargetFormModel = /** @class */ (function () {
    function FloorTargetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.floorThreshold, floorThreshold = _b === void 0 ? 1 : _b, _c = _a.floorConditions, floorConditions = _c === void 0 ? 'greater' : _c;
        this.floorThreshold = floorThreshold;
        this.floorConditions = floorConditions;
    }
    FloorTargetFormModel.assign = function (data) {
        return new FloorTargetFormModel(data);
    };
    return FloorTargetFormModel;
}());
var AgeBuildFormModel = /** @class */ (function () {
    function AgeBuildFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, _b = _a.ageBuiltThreshold, ageBuiltThreshold = _b === void 0 ? 1 : _b, _c = _a.ageBuiltConditions, ageBuiltConditions = _c === void 0 ? 'greater' : _c;
        this.ageBuiltThreshold = ageBuiltThreshold;
        this.ageBuiltConditions = ageBuiltConditions;
    }
    AgeBuildFormModel.assign = function (data) {
        return new AgeBuildFormModel(data);
    };
    return AgeBuildFormModel;
}());
var FloorPlanFormModel = /** @class */ (function () {
    function FloorPlanFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item.floorPlans, floorPlans = _a === void 0 ? [] : _a;
        this.floorPlans = floorPlans;
    }
    FloorPlanFormModel.assign = function (data) {
        return new FloorPlanFormModel(data);
    };
    return FloorPlanFormModel;
}());
